module.exports = __webpack_public_path__ + "static/media/mbis_img_5.64644c5b.png";